import axiosClient from './axiosClient';

const garantiasApi = {
  getGarantias: (params) => axiosClient.get('/garantias', { params }),
  getGarantia: (id) => axiosClient.get(`/garantias/${id}`),
  createGarantia: (data) => axiosClient.post('/garantias', data),
  updateGarantia: (id, data) => axiosClient.put(`/garantias/${id}`, data),
  deleteGarantia: (id) => axiosClient.delete(`/garantias/${id}`),

  // Reconoce un codigo escaneado o escrito: N.° de boleta/factura/nota de venta (o el QR de
  // SUNAT), serie de una unidad vendida o codigo de barras/SKU de un producto.
  lookupCode: (code) => axiosClient.get('/garantias/lookup', { params: { code } }),

  // Fotos de evidencia (hasta 3 por garantia, ver GarantiaImageController): una por una, en
  // su propio POST, igual que las imagenes de producto.
  uploadGarantiaImage: (garantiaId, file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axiosClient.post(`/garantias/${garantiaId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteGarantiaImage: (garantiaId, imageId) => axiosClient.delete(`/garantias/${garantiaId}/images/${imageId}`),
};

export default garantiasApi;
